<mbs-modal
  #modal
  [isCustomModal]="true"
  [showFooter]="true"
  [title]="baseModal.data.title"
  [titleTextOverflow]="true">
  <div modal-body>
    @if (baseModal.data.isTrial === false) {
      {{ 'shared:licenses.releaseTrialModal.descriptionNotTrial' | i18next }}
    } @else {
      {{ 'shared:licenses.releaseTrialModal.description' | i18next }}
    }
    <mbs-alert
      *ngIf="baseModal.data.isDeepInstinct"
      class="mt-2"
      [icon]="true"
      [type]="MbsPopupType.warning">
      The instance of Deep Instinct will be uninstalled from the target computer. If the computer is currently offline, this will be done
      once it is online again
    </mbs-alert>
  </div>
  <ng-container modalFooter>
    <mbs-button
      type="primary"
      [loading]="loading"
      (click)="release()"
      >{{ 'shared:licenses.releaseModal.submit' | i18next: { format: 'title' } }}
    </mbs-button>
    <mbs-button
      data-dismiss="modal"
      type="secondary"
      (click)="modal.close()"
      >{{ 'shared:licenses.common.cancel' | i18next: { format: 'title' } }}
    </mbs-button>
  </ng-container>
</mbs-modal>
